// Daily supply cost per man by physical size (gp), mirroring the engine's poolSupplyCost
// table so client-side totals match what advance-day charges. A unit pays for its man size
// plus, if mounted, its beast size. Accepts a pool row or a catalog type (same field names).
// BALANCE PASS 2026-07-26: halved (×0.5) to match the engine — keep these two tables in step.
export const MAN_SUPPLY = { Tiny: 0.025, Small: 0.05, Medium: 0.05, Large: 0.2, Huge: 0.45 }
export const BEAST_SUPPLY = { Tiny: 0.0125, Small: 0.025, Medium: 0.025, Large: 0.1, Huge: 0.4 }
const cap = (s) => (s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : s) // legacy pools use 'medium'

export const supplyPerMan = (t) =>
  (MAN_SUPPLY[cap(t.supply_size)] || 0) + (t.mount_supply_size ? (BEAST_SUPPLY[cap(t.mount_supply_size)] || 0) : 0)
